<template>

    <div class="">

        <div class="bg-light py-3">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb m-0">
                        <li class="me-2">Sie sind hier:</li>
                        <li class="breadcrumb-item">
                            <inertia-link :href="route('home')">Startseite</inertia-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            <inertia-link :href="route('categories.show', 'dienstleistungen')">Dienstleistungen</inertia-link>
                        </li>
                    </ol>
                </nav>
            </div>
        </div>

        <div class="bg-light mb-5 py-5">
            <div class="container text-center" style="max-width: 1000px;">
                <h1 class="display-3 fw-light mb-5" style="letter-spacing: -2px;">
                    <span class="">CarFleet24</span> bietet Ihnen für fast jeden Fuhrpark <span class="">professionelle Lösungen</span> an
                </h1>
                <div class="mb-5">
                    <img src="https://www.dentagen.de/wp-content/uploads/carfleet24-logo_4c.jpg" alt="" class="img-fluid" />
                </div>
                <div class="fs-4">
                    <i>CarFleet24</i> vermittelt Ihnen, Ihren Familienangehörigen und Mitarbeitern Neufahrzeuge zu Sonderkonditionen – direkt vom deutschen VertragsLieferant/-partner.
                </div>
            </div>
        </div>


        <div class="container">

            <div class="row g-5 row-cols-1 row-cols-lg-3">
                <div class="col">
                    <div class="mb-3">
                        <span class="fs-1 text-primary">
                            <i class="bi bi-list-check"></i>
                        </span>
                    </div>
                    <h2 class="mb-3 text-uppercase fs-5">Konditionen</h2>
                    <p class="fw-light fs-5 mb-3">Aktuelle Angebote, Konditionen und Ansprechpartner sind für DENTAGEN-Mitglieder.</p>
                    <p>
                        <a href="#!" class="btn btn-outline-primary">Jetzt anfragen</a>
                    </p>
                </div>
                <div class="col">
                    <div class="mb-3">
                        <span class="fs-1 text-primary">
                            <i class="bi bi-person-lines-fill"></i>
                        </span>
                    </div>
                    <h2 class="mb-3 text-uppercase fs-5">Kontakt</h2>
                    <p class="fw-light fs-5">FleetXpert Gesellschaft für LeaseFinanz und Flottenmanagement</p>
                    <p>
                        <a href="#!" class="btn btn-outline-primary">Jetzt anfragen</a>
                    </p>
                </div>
                <div class="col">
                    <div class="mb-3">
                        <span class="fs-1 text-primary">
                            <i class="bi bi-list-check"></i>
                        </span>
                    </div>
                    <h2 class="mb-3 text-uppercase fs-5">Konditionen</h2>
                    <p class="fw-light fs-5">Aktuelle Angebote, Konditionen und Ansprechpartner sind für DENTAGEN-Mitglieder.</p>
                    <p>
                        <a href="#!" class="btn btn-outline-primary">Jetzt anfragen</a>
                    </p>
                </div>
            </div>
        </div>

        <div class="bg-dark text-white-50 my-5 p-5">
            <div class="container narrow-container text-center my-5">
                <p class="display-6 fw-light mb-5">
                    Dank eines eigenen bundesweiten Lieferanten-Netzwerks kann <i>CarFleet24</i> Neuwagen der meistgefragten Automarken jederzeit kompetent, seriös, zuverlässig und günstig vermitteln.
                </p>
                <p class="lead">
                    Marken wie Alfa Romeo, Audi, BMW, Citroën, Fiat, Ford, Honda, Hyundai, Lancia, Lexus, Mercedes Benz, Mini, Nissan, Opel, Peugeot, Porsche, Renault, Seat, Skoda, Suzuki, Toyota, Volvo, VW und viele weitere werden von <i>CarFleet24</i> angeboten.
                </p>
            </div>
        </div>

        <div class="container">

            <div class="row align-items-center">
                <div class="col-md-7">
                    <h2 class="display-4 fw-light">First featurette heading. <span class="text-muted">It’ll blow your mind.</span></h2>
                    <p class="lead">Some great placeholder content for the first featurette here. Imagine some exciting prose here.</p>
                </div>
                <div class="col-md-5">
                    <img src="/img/cars/auto-1634815_640.jpg" alt="" class="img-fluid" />
                </div>
            </div>

            <hr class="my-5" />

            <div class="row  align-items-center">
                <div class="col-md-7 order-md-2">
                    <h2 class="display-4 fw-light">Oh yeah, it’s that good. <span class="text-muted">See for yourself.</span></h2>
                    <p class="lead">Another featurette? Of course. More placeholder content here to give you an idea of how this layout would work with some actual real-world content in place.</p>
                </div>
                <div class="col-md-5 order-md-1">
                    <img src="/img/cars/man-802120_640.jpg" alt="" class="img-fluid" />
                </div>
            </div>

            <hr class="my-5" />

            <div class="row  align-items-center">
                <div class="col-md-7">
                    <h2 class="display-4 fw-light">And lastly, this one. <span class="text-muted">Checkmate.</span></h2>
                    <p class="lead">And yes, this is the last block of representative placeholder content. Again, not really intended to be actually read, simply here to give you a better view of what this would look like with some actual content. Your content.</p>
                </div>
                <div class="col-md-5">
                    <img src="/img/cars/traffic-3612474_640.jpg" alt="" class="img-fluid" />
                </div>
            </div>

            <hr class="my-5" />

            <!-- /END THE FEATURETTES -->


            <div class="row justify-content-center">
                <div class="col-md-6">
                    <div class="text-center">
                        <h2 class="display-3 mb-5">Angebot anfordern</h2>
                        <p class="lead mb-5">Paragraph of text beneath the heading to explain the heading. We'll add onto it with another sentence and probably just keep going until we run out of words.</p>
                    </div>
                    <form @submit.prevent="form.post(route('landingpage'), { preserveScroll: true })">
                        <text-input label="Name" v-model="form.name" :error="form.errors.name" />
                        <text-input label="E-Mail-Address" v-model="form.email" type="email" :error="form.errors.email" />
                        <text-input label="phone" v-model="form.phone" type="tel" :error="form.errors.phone" />
                        <textarea-input label="Message" v-model="form.message" :error="form.errors.message" />
                        <submit-button :form="form" />
                    </form>

                    <div class="alert alert-success mt-3" v-if="messageSent">
                        {{ __('Vielen Dank für Ihre Nachricht.') }}
                    </div>
                </div>
            </div>

        </div>
    </div>

</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';

    import Breadcrumbs from '@/shared/Breadcrumbs';


    export default {
        props: [
            'messageSent',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    name: null,
                    email: null,
                    phone: null,
                    message: null,
                }),
            }
        },
        components: {
            TextInput,
            TextareaInput,
            SubmitButton,
            Breadcrumbs,

        },
        methods: {
        },
    }
</script>

<style scoped>
    .container {
    }
</style>